import { render, staticRenderFns } from "./ViewTitleModal.vue?vue&type=template&id=225a95f0&"
import script from "./ViewTitleModal.vue?vue&type=script&lang=js&"
export * from "./ViewTitleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('225a95f0')) {
      api.createRecord('225a95f0', component.options)
    } else {
      api.reload('225a95f0', component.options)
    }
    module.hot.accept("./ViewTitleModal.vue?vue&type=template&id=225a95f0&", function () {
      api.rerender('225a95f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/ViewTitleModal.vue"
export default component.exports